/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/gmap-button-icon': {
    width: 43,
    height: 43,
    viewBox: '0 0 43 43',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M43 29c0 7.732-6.268 14-14 14H14C6.268 43 0 36.732 0 29V14C0 6.268 6.268 0 14 0h15c7.732 0 14 6.268 14 14v15z" _fill="#0A0A0A"/><mask id="svgicon_icons_gmap-button-icon_a" maskUnits="userSpaceOnUse" x="0" y="0" width="44" height="44"><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M43 29c0 7.732-6.268 14-14 14H14C6.268 43 0 36.732 0 29V14C0 6.268 6.268 0 14 0h15c7.732 0 14 6.268 14 14v15z" _fill="#fff"/></mask><path pid="2" d="M31.349 23.93H23.5l-.5-.43V21l.5-.838h7.849V23.93zm-1.884 1.884v7.535h-9.42V39L8.744 33.35V8.859h20.722v9.42H27.58v-7.536H12.51l7.535 3.768v16.954h7.535v-5.651h1.884z" _fill="#fff"/><path pid="3" d="M23.5 23.93l-.5-.43V21l.5-.838V18L21 22l2.5 4v-2.07z" _fill="#fff"/>'
  }
})
